import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "estudia_token";

export const api = axios.create({ baseURL: API, timeout: 60_000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(error, fallback = "Algo no salio bien. Intenta de nuevo.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  if (error?.code === "ECONNABORTED") return "La solicitud tardo demasiado. Intenta de nuevo.";
  if (error?.message === "Network Error") return "No pudimos conectar con el servidor.";
  return fallback;
}

export async function streamAssistant({ studentId, question, onDelta }) {
  const token = localStorage.getItem(TOKEN_KEY);
  const response = await fetch(`${API}/assistant/ask`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ student_id: studentId, question }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.detail || "El asistente no esta disponible.");
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const line = part.replace(/^data:\s*/, "").trim();
      if (!line) continue;
      const payload = JSON.parse(line);
      if (payload.delta) onDelta(payload.delta);
      if (payload.error) throw new Error(payload.error);
    }
  }
}
